<template>
  <div class="main-container">
    <div class="app-content">
      <div class="logo-container">
        <img v-if="_logo === 'logo-tink.svg'" src="../assets/images/logo-tink.svg" alt="tink"/>
        <img v-if="_logo === 'logo-vf.svg'" src="../assets/images/logo-vf.svg" alt="tink"/>
        <img v-if="_logo === 'logo-co.svg'" src="../assets/images/logo-co.svg" alt="tink"/>
        <img v-if="_logo === 'logo-st.svg'" src="../assets/images/logo-st.svg" alt="tink"/>
      </div>
      <div class="app-title">
        <h2 class="main-title">{{ $t("main-title") }}</h2>
      </div>
      <div class="app-text" v-html="$t('description')"></div>
      <div class="app-form">
        <div class="form-title">{{ $t("form-title") }}</div>
        <div class="form-elements">
          <div class="form-inner">
            <div class="input-group mb-4">
              <input type="text" name="name" v-model="formData.name" :placeholder="$t('form-placeholder-name')"
                     autocomplete="off" class="form-control inputBox form-control"
                     :class="v$.formData.name.$error ? 'is-invalid' : ''" :area-invalid="v$.formData.name.$error"/>
              <div class="invalid-feedback text-left" v-if="v$.formData.name.$errors">
                <span class="mb-0" v-for="error in v$.formData.name.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-inner">
            <div class="input-group mb-4">
              <input type="text" name="surname" v-model="formData.surname" :placeholder="$t('form-placeholder-surname')"
                     autocomplete="off" class="form-control inputBox" :area-invalid="v$.formData.surname.$error"/>
              <div class="invalid-feedback d-block" v-if="v$.formData.surname.$error">
                <span class="mb-0" v-for="error in v$.formData.surname.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-inner">
            <div class="input-group mb-4">
              <input type="email" name="email" v-model="formData.email" :placeholder="$t('form-placeholder-email')"
                     autocomplete="off" class="form-control inputBox" :area-invalid="v$.formData.email.$error"/>
              <div class="invalid-feedback d-block" v-if="v$.formData.email.$error">
                <span class="mb-0" v-for="error in v$.formData.email.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-inner">
            <div class="input-group mb-4">
              <input type="text" name="orderno" v-model="formData.orderNo"
                     :placeholder="$t('form-placeholder-orderno')" autocomplete="off" class="form-control inputBox"
                     :area-invalid="v$.formData.email.$error"/>
              <div class="invalid-feedback d-block" v-if="v$.formData.orderNo.$error">
                <span class="mb-0" v-for="error in v$.formData.orderNo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-inner">
            <div class="input-group mb-4">
              <div class="form-title mb-4">{{ $t("form-title-type") }}</div>
              <div class="tink-radio">
                <div class="custom-control custom-radio mb-3">
                  <input type="radio" name="Bestelkunde" v-model="formData.orderType"
                         :value="$t('form-placeholder-type-ordinary')" checked="checked" class="custom-control-input"
                         id="__BVID__26"/>
                  <label class="custom-control-label" for="__BVID__26">
                    <span class="radio-text"> {{ $t("form-placeholder-type-ordinary") }} </span>
                  </label>
                </div>
                <div class="custom-control custom-radio" style="margin-top: 10px">
                  <input type="radio" name="Bestelkunde" v-model="formData.orderType"
                         :value="$t('form-placeholder-type-extraordinary')" class="custom-control-input"
                         id="__BVID__27"/>
                  <label class="custom-control-label" for="__BVID__27">
                    <span class="radio-text"> {{ $t("form-placeholder-type-extraordinary") }} </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-inner">
            <div class="input-group mb-4" v-if="formData.orderType === $t('form-placeholder-type-extraordinary')">
              <textarea v-model="formData.agreementReason" :placeholder="$t('form-placeholder-reason')"
                        class="tink-textarea form-control" style="resize: none; overflow-y: scroll; height: 86px"/>
            </div>
          </div>
          <DatePicker
              ref="datepicker"
              :select-text="$t('form-datepicker-text-select')"
              :cancel-text="$t('form-datepicker-text-cancel')"
              :placeholder="$t('form-placeholder-date')"
              v-model="formData.agreementDate"
              :value="formData.agreementDate"
              inputClassName="form-control ps-5 inputBox mx-input"
              :enableTimePicker="false"
              :format="'dd-MM-yyyy'"
              :min-date="myMinDate"
              :start-date="myMinDate"
              auto-apply
              :clearable="false"
          >
            <template #input-icon>
              <img class="input-slot-image" src="../assets/images/date.svg" alt="tink"/>
            </template>
          </DatePicker>
          <div class="form-inner">
            <button type="button" class="btn btn-primary tink-submit-button undefined" :class="_color"
                    :disabled="isDisabled" @click="submit">{{ $t("form-submit-button") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import {alpha, email, helpers, minLength, required} from "@vuelidate/validators";
import {mapGetters, mapMutations} from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      pdfData: null,
      submitted: false,
      isDisabled: false,
      emailTemplate: null,
      date: moment().format("DD-MM-YYYY HH:mm:ss"),
      v$: useValidate(),
      formData: {
        name: null,
        surname: null,
        email: null,
        orderNo: null,
        agreementDate: null,
        orderType: this.$t("form-placeholder-type-ordinary"),
        agreementReason: null,
        orderTypeDate: 14,
      },
    };
  },
  computed: {
    ...mapGetters({
      _logo: "_logo",
      _color: "_color",
    }),
    myMinDate() {
      return moment(new Date()).add(15, 'days');
    }
  },
  methods: {
    ...mapMutations({
      add: "add",
    }),
    submit() {
      this.v$.$validate();

      if (!this.v$.$error) {
        this.isDisabled = true;

        let listData = {
          firstname: this.formData.name,
          surname: this.formData.surname,
          email: this.formData.email,
          orderNumber: this.formData.orderNo,
          cancellationType: this.formData.orderType,
          cancellationReason: this.formData.agreementReason ?? '-',
          cancellationDate: this.formData.agreementDate ? moment(this.formData.agreementDate).format("DD-MM-YYYY") : '-',
          store: "de",
          pdf: this.pdfData,
          emailContent: this.emailTemplate,
        };
        this.add(listData);
        this.$router.push("summary");
      }
    },
  },
  validations() {
    return {
      formData: {
        name: {
          alpha: helpers.withMessage(this.$t("validate-message-name"), alpha),
          required: helpers.withMessage(this.$t("validate-message-name"), required),
          min: helpers.withMessage(this.$t("validate-message-name"), minLength(3)),
        },
        surname: {
          alpha: helpers.withMessage(this.$t("validate-message-surname"), alpha),
          required: helpers.withMessage(this.$t("validate-message-surname"), required),
          min: helpers.withMessage(this.$t("validate-message-surname"), minLength(3)),
        },
        email: {
          email: helpers.withMessage(this.$t("validate-message-emailxx"), email),
          required: helpers.withMessage(this.$t("validate-message-emailxx"), required),
        },
        orderNo: {
          required: helpers.withMessage(this.$t("validate-message-ordernum"), required),
        },
      },
    };
  },
};
</script>
